<template>
  <div class="scan-result" :class="modeClass">
    <div class="result-icon">
      <svg v-if="mode === 'success'" xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="m10.6 16.6l7.05-7.05l-1.4-1.4l-5.65 5.65l-2.85-2.85l-1.4 1.4l4.25 4.25ZM12 22q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22Z"/>
      </svg>
      <svg v-else-if="mode === 'warning'" xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="M12 2L1 21h22L12 2zm0 4.45L19.53 19H4.47L12 6.45zM11 10h2v5h-2zm0 6h2v2h-2z"/>
      </svg>
      <svg v-else-if="mode === 'pendencia'" xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM9 6c0-1.66 1.34-3 3-3s3 1.34 3 3v2H9V6zm9 14H6V10h12v10zm-6-3c1.1 0 2-.9 2-2s-.9-2-2-2s-2 .9-2 2s.9 2 2 2z"/>
      </svg>
      <svg v-else xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" aria-hidden="true">
        <path fill="currentColor" d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10s10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17L12 13.41L8.41 17L7 15.59L10.59 12L7 8.41L8.41 7L12 10.59L15.59 7L17 8.41L13.41 12z"/>
      </svg>
    </div>

    <p v-if="mode !== 'error' && participant?.name" class="result-name">{{ participant.name }}</p>

    <p class="result-status">
      <span v-if="mode === 'success'">Check-in confirmado!</span>
      <span v-else-if="mode === 'warning'">Já estava confirmado</span>
      <span v-else-if="mode === 'pendencia'">Pendência financeira</span>
      <span v-else>{{ errorMessage || 'QR Code inválido' }}</span>
    </p>

    <p v-if="mode === 'pendencia' && participant" class="pendencia-detail">
      Falta <strong>R$ {{ formatFalta(participant.falta) }}</strong> para liberar o check-in
    </p>

    <div v-if="(mode === 'success' || mode === 'warning') && participant" class="result-meta">
      <EquipeChip v-if="participant.equipe" :equipe="participant.equipe" />
      <TransporteBadge v-if="participant.transporte" :value="participant.transporte" size="large" />
    </div>

    <div v-else-if="mode === 'pendencia' && participant" class="result-meta">
      <EquipeChip v-if="participant.equipe" :equipe="participant.equipe" />
    </div>

    <a
      v-if="mode === 'pendencia' && whatsappLink"
      :href="whatsappLink"
      target="_blank"
      rel="noopener"
      class="btn-cobrar-wpp"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M.057 24l1.687-6.163a11.867 11.867 0 0 1-1.587-5.946C.16 5.335 5.495 0 12.05 0a11.817 11.817 0 0 1 8.413 3.488a11.824 11.824 0 0 1 3.48 8.414c-.003 6.557-5.338 11.892-11.893 11.892a11.9 11.9 0 0 1-5.688-1.448zm6.597-3.807c1.676.995 3.276 1.591 5.392 1.592c5.448 0 9.886-4.434 9.889-9.885c.002-5.462-4.415-9.89-9.881-9.892c-5.452 0-9.887 4.434-9.889 9.884a9.86 9.86 0 0 0 1.667 5.39l-.999 3.648zM12.05 5.97c-.34-.011-.66-.011-.971.062c-.32.075-.71.273-1.072.638c-.371.366-1.402 1.37-1.402 3.345s1.435 3.881 1.635 4.146c.2.264 2.79 4.267 6.844 5.978c.961.413 1.722.66 2.317.842c.985.314 1.881.27 2.591.165c.79-.117 2.448-1.002 2.79-1.97c.343-.97.343-1.797.24-1.973c-.103-.175-.376-.279-.785-.487c-.41-.207-2.42-1.197-2.795-1.334c-.376-.137-.65-.205-.923.207c-.275.412-1.06 1.334-1.299 1.609c-.24.275-.479.309-.888.103c-.41-.207-1.732-.638-3.297-2.035c-1.219-1.085-2.04-2.422-2.279-2.832c-.24-.412-.024-.635.184-.84c.184-.184.41-.479.617-.718c.207-.24.276-.412.412-.687c.137-.275.07-.514-.034-.722c-.103-.207-.918-2.214-1.293-3.026c-.349-.755-.694-.638-.923-.638z"/></svg>
      <span>Cobrar via WhatsApp</span>
    </a>

    <button class="btn-primary restart-btn" @click="$emit('restart')">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24"><path fill="currentColor" d="M17.65 6.35A7.958 7.958 0 0 0 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08A5.99 5.99 0 0 1 12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"/></svg>
      <span>Escanear outro</span>
    </button>
  </div>
</template>

<script>
import EquipeChip from './EquipeChip.vue'
import TransporteBadge from './TransporteBadge.vue'
import { buildWhatsAppLink } from '../lib/financeiro'

export default {
  name: 'ScanResult',
  components: { EquipeChip, TransporteBadge },
  props: {
    // 'success' | 'warning' | 'pendencia' | 'error'
    mode: { type: String, required: true },
    participant: { type: Object, default: null },
    errorMessage: { type: String, default: '' }
  },
  emits: ['restart'],
  computed: {
    modeClass() { return `result-${this.mode}` },
    whatsappLink() {
      return this.participant ? buildWhatsAppLink(this.participant) : null
    }
  },
  methods: {
    formatFalta(v) {
      if (v === null || v === undefined) return '—'
      return Number(v).toFixed(2).replace('.', ',')
    }
  }
}
</script>

<style scoped>
.scan-result {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-base);
  padding: var(--spacing-xl);
  width: 100%;
  max-width: 420px;
  text-align: center;
  background: var(--color-bg-surface);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-card);
}
.result-success .result-icon { color: var(--color-success); }
.result-warning .result-icon { color: var(--color-warning); }
.result-pendencia .result-icon { color: var(--color-danger); }
.result-error .result-icon { color: var(--color-danger); }

.result-name {
  font-size: var(--text-2xl);
  font-weight: 800;
  color: var(--color-text-primary);
  margin: 0;
  word-break: break-word;
}
.result-status {
  font-size: var(--text-lg);
  font-weight: 700;
  margin: 0;
}
.result-success .result-status { color: var(--color-success); }
.result-warning .result-status { color: var(--color-warning); }
.result-pendencia .result-status { color: var(--color-danger); }
.result-error .result-status { color: var(--color-danger); }

.pendencia-detail {
  font-size: var(--text-md);
  color: var(--color-text-secondary);
  margin: 0;
}
.pendencia-detail strong { color: var(--color-danger); font-size: var(--text-lg); }

.result-meta {
  display: flex;
  align-items: center;
  gap: var(--spacing-md);
  flex-wrap: wrap;
  justify-content: center;
}

.btn-cobrar-wpp {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-sm);
  width: 100%;
  padding: 12px 20px;
  background: #25d366;
  color: #fff;
  border: none;
  border-radius: var(--radius-md);
  font-size: var(--text-md);
  font-weight: 700;
  cursor: pointer;
  text-decoration: none;
  transition: var(--transition-fast);
}
.btn-cobrar-wpp:hover { background: #1ebe5d; }

.restart-btn {
  justify-content: center;
  width: 100%;
  padding: 14px 20px;
  font-size: var(--text-md);
  margin-top: var(--spacing-sm);
}
</style>
